import React from 'react';
import { Link } from '@tanstack/react-router';

import MemoryFilesGridItemPreview from '../../../MemoryForm/FilesGridItemPreview';

import { getFileProgress } from '../../../../helpers/file';

import type { Asset } from '../../../../types/asset';
import type { AssetGroup } from '../../../../types/asset-group';

import '@awesome.me/webawesome/dist/components/select/select.js';

interface DashboardAdminAssetsAddItemProps {
  asset: Asset;
  assetGroups: AssetGroup[];
  handleChange: Function;
  handleDelete: Function;
};

const DashboardAdminAssetsAddItem: React.FC<DashboardAdminAssetsAddItemProps> = ({ asset, assetGroups, handleChange, handleDelete }) => {
  return (
    <tr className="dashboard-admin-asset">
      <td className="thumbnail">
        <MemoryFilesGridItemPreview file={asset} />
        {(asset.progress && !asset.progress.uploadComplete) && (
          <wa-progress-bar
            className="progress"
            value={getFileProgress(asset)}
            label="Upload progress"
            style={{ '--track-height': '6px' } as Record<string, string>}
          ></wa-progress-bar>
        )}
      </td>
      <td>
        <wa-input
          size="s"
          placeholder="Image title"
          value={asset.title}
          onChange={(e: any) => handleChange(asset.id, { title: e.target.value })}
        ></wa-input>
      </td>
      <td>
        <wa-select
          className="dashboard-admin-asset-groups-select"
          size="s"
          multiple
          placeholder="Select groups"
          onChange={(e: any) => handleChange(asset.id, { groups: e.target.value })}
        >
          {assetGroups.map(group => (
            <wa-option key={group.id} value={group.id}>{group.name}</wa-option>
          ))}
        </wa-select>
      </td>
      <td>
        <wa-checkbox
          size="s"
          checked={asset.metadata.hidden}
          onChange={(e: any) => handleChange(asset.id, { hidden: e.target.checked })}
        ></wa-checkbox>
      </td>
      <td className="actions">
        <div className="wa-cluster wa-gap-2xs">
          <Link to="#delete" id={`asset-${asset.id}-delete`} onClick={(e) => { e.preventDefault(); handleDelete(asset.id); }}>
            <i className="fa-light fa-trash" />
          </Link>
          <wa-tooltip for={`asset-${asset.id}-delete`} placement="top">
            Delete asset
          </wa-tooltip>
        </div>
      </td>
    </tr>
  );
}

export default DashboardAdminAssetsAddItem;
